import { render, staticRenderFns } from "./DownlineRepPersonalAddressContent.vue?vue&type=template&id=4b99c168&"
import script from "./DownlineRepPersonalAddressContent.vue?vue&type=script&lang=js&"
export * from "./DownlineRepPersonalAddressContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports